import { defaultSortId } from 'constants/salesPeriods';
import {
    SET_LOADING_SALES_PERIODS_STATUS,
    SET_SALES_PERIOD_DATA,
    RESET_SALES_PERIOD_DATA,
    UPDATE_SELECTED_PERIOD,
    UPDATE_SELECTED_SORT_OPTION,
    DELETE_SALES_PERIOD,
    CREATE_SALES_PERIOD_ACTION_START,
    CREATE_SALES_PERIOD_ACTION_ERROR,
    CREATE_SALES_PERIOD_ACTION_SUCCESS,
    UPDATE_SALES_PERIOD,
} from 'actions/salesPeriods';
import { getNextSelectedPeriodId } from 'components/SalesPeriods/salesPeriodHelper';

const initialState = {
    isLoading: false,
    isError: false,
    message: '',
    currentPeriodId: null,
    sortId: defaultSortId,
    data: [],
};

const actionsMap = {
    [CREATE_SALES_PERIOD_ACTION_START]: (state, action) => {
        return {
            ...state,
            isLoading: true,
            isError: false,
            message: '',
        };
    },
    [CREATE_SALES_PERIOD_ACTION_ERROR]: (state, action) => {
        return {
            ...state,
            isLoading: false,
            isError: true,
            message: action.payload,
        };
    },
    [CREATE_SALES_PERIOD_ACTION_SUCCESS]: (state, action) => {
        return {
            ...state,
            isLoading: false,
            currentPeriodId: action.payload.periodId,
            data: [...state.data, action.payload]
        };
    },
    [SET_LOADING_SALES_PERIODS_STATUS]: (state, action) => (
        {
            ...state,
            isLoading: action.isLoading
        }
    ),
    [SET_SALES_PERIOD_DATA]: (state, action) => {
        const { data, latestId: currentPeriodId } = action.payload || {};
        return {
            ...state,
            data,
            currentPeriodId,
        }
    },
    [RESET_SALES_PERIOD_DATA]: () => initialState,
    [UPDATE_SELECTED_PERIOD]: (state, action) => (
        {
            ...state,
            currentPeriodId: action.selectedPeriodId,
        }
    ),
    [UPDATE_SELECTED_SORT_OPTION]: (state, action) => (
        {
            ...state,
            sortId: action.selectedSortId,
        }
    ),
    [DELETE_SALES_PERIOD]: (state, action) => {
        const deletedId = action.deletedId;
        return {
            ...state,
            currentPeriodId: getNextSelectedPeriodId(deletedId, state.data, state.sortId),
            data: state.data.filter(item => item.periodId !== deletedId),
        }
    },
    [UPDATE_SALES_PERIOD]: (state, action) => (
        {
            ...state,
            data: state.data.map(item => item.periodId === action.data.periodId ? { ...action.data } : { ...item }),
        }
    ),
};

export default function salesPeriods(state = initialState, action = {}) {
    const fn = actionsMap[action.type];
    return fn ? fn(state, action) : state;
}
